/**
 *
 * v.1.0  10/09/25  Inicial
 * v.1.1  11/09/25 Añadido componentDidUpdate
 **/

import React from 'react'
import PropTypes from 'prop-types';


class InputCodigoId extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            valor: props.valor || "",
        };
    }


    componentDidUpdate(prevProps) {
        if (prevProps.valor !== this.props.valor) {
            this.setState({ valor: this.props.valor?.toString() || "" });
        }
    }


    handleChange = (event) => {
        const { maxLength = 5 } = this.props;

        // Solo dígitos y limitar longitud
        let nuevoValor = event.target.value.replace(/\D/g, "").slice(0, maxLength);

        this.setState({ valor: nuevoValor });

        if (this.props.onChange) {
            this.props.onChange(nuevoValor);
        }
    };

    handleBlur = () => {
        const { maxLength = 5, padWithZeros = true } = this.props;
        let { valor } = this.state;

        if (valor && padWithZeros) {
            valor = valor.padStart(maxLength, "0");
            this.setState({ valor });

            if (this.props.onChange) {
                this.props.onChange(valor);
            }
        }
    };

    render() {
        const {valor} = this.state;
        const { maxLength = 5 } = this.props;
        //console.log("InputCodigoId - RENDER");
        //console.log("valor: ", valor);
        return (
            <input
                type="text"
                value={valor}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                maxLength={maxLength}
            />
        );
    }

}


InputCodigoId.propTypes = {
    className: PropTypes.string,
    valor: PropTypes.number,
    onChange: PropTypes.func,
    maxLength: PropTypes.number,
    padWithZeros: PropTypes.bool
}

export default InputCodigoId